import { render, staticRenderFns } from "./LkAccessOverlay.vue?vue&type=template&id=4fa7347e&scoped=true"
import script from "./LkAccessOverlay.vue?vue&type=script&lang=js"
export * from "./LkAccessOverlay.vue?vue&type=script&lang=js"
import style0 from "./LkAccessOverlay.vue?vue&type=style&index=0&id=4fa7347e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa7347e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseTooltip: require('/var/www/git/queue/front/components/BaseTooltip.vue').default})
